import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

import '../styles/MastheadPlaceholder.css';

/**
 * MastheadPlaceholder Component
 *
 * Renders a Sitecore JSS placeholder for dynamic content.
 *
 * Props:
 * - rendering: The Sitecore JSS rendering context.
 * - placeholderName: Name of the placeholder defined in Sitecore.
 */

const MastheadPlaceholder = ({ rendering, placeholderName = 'placeholder' }) => (
  <div className="masthead__overlay__placeholder">
    <Placeholder name={placeholderName} rendering={rendering} />
  </div>
);

export default MastheadPlaceholder;
